import { createStore } from 'vuex';
import ui from './modules/ui';
import regions from './modules/regions';
import filters from './modules/filters';
import contact from './modules/contact';
import common from './modules/common';
import analytics from './modules/analytics';
import priceCalculator from './modules/price-calculator';

export default function create() {
  return createStore({
    strict: true,
    modules: {
      ui,
      regions,
      filters,
      common,
      contact,
      priceCalculator,
      analytics,
    },
  });
}
